<template>
    <isc-scrollbar class="wrap">
        <transition-group name="flip-list" tag="div" class="header__tabs">
            <div
                v-for="tab in tabList"
                :key="tab.instanceId"
                class="header__tabs__item"
                :class="{ active: currentTabId === tab.instanceId }"
                @click="tabClick(tab)"
                @contextmenu.prevent="(ev) => onContext(tab, ev)"
            >
                <div class="activator">
                    <div class="name text-truncate">{{ tab._configs.name }}</div>
                    <i class="isc-icon-bold-close del" @click.stop="deleteTab(tab)"></i>
                </div>
                <div class="bottom-bg"></div>
                <com-menu
                    v-if="menuId === tab.instanceId"
                    class="menu"
                    :style="{ left: menuX + 'px', top: menuY + 'px' }"
                    @click="closeMenu"
                    @mouseleave.native="closeMenu"
                >
                    <com-menu-item>重新加载</com-menu-item>
                    <com-menu-item>关于</com-menu-item>
                    <com-menu-item separator></com-menu-item>
                    <com-menu-item @click="deleteTab(tab)">关闭</com-menu-item>
                    <com-menu-item>关闭其他</com-menu-item>
                    <com-menu-item>关闭左侧</com-menu-item>
                    <com-menu-item>关闭右侧</com-menu-item>
                </com-menu>
            </div>
        </transition-group>
    </isc-scrollbar>
</template>

<script>
import { objectAssign } from '@isyscore/utils/object';
import ComMenuItem from '../common/com-menu-item.vue';
import ComMenu from '../common/com-menu.vue';
export default {
    components: { ComMenuItem, ComMenu },
    data() {
        return {
            /**
             * @type {App[]}
             */
            tabList: [],
            openedAppMap: {},
            menuId: -1,
            menuX: 0,
            menuY: 0
        };
    },
    computed: {
        currentTabId() {
            return this.$store.state.appManager.currentAppId;
        },
        tabListIds() {
            return this.$store.state.appManager.openedAppIds;
        }
    },
    watch: {
        tabListIds: {
            handler(newVal) {
                const openedApps = objectAssign(Object.create(null), this.$appManager.openedAppMap);
                this.tabList = newVal.map((id) => openedApps[id]);
            },
            immediate: true
        }
    },

    methods: {
        /**
         *
         * @param tab {App}
         */
        tabClick(tab) {
            this.$appManager.activeApp(tab.instanceId);
        },

        /**
         *
         * @param tab {App}
         */
        deleteTab(tab) {
            this.$appManager.closeApp(tab.instanceId);
        },

        /**
         * @todo 实现选项卡右键菜单
         * @param tab {App}
         * @param ev {Event}
         */
        onContext(tab, ev) {
            // const itemEl = ev.path.find((p) => p.classList.contains('header__tabs__item'));
            //
            // if (!itemEl) return;
            //
            // const { left, top } = itemEl.getBoundingClientRect();
            // const { clientX, clientY } = ev;
            // this.menuId = tab.instanceId;
            // this.menuX = clientX - left - 10;
            // this.menuY = clientY - top - 10;
        },

        closeMenu() {
            this.menuId = -1;
        }
    }
};
</script>

<style lang="scss">
.wrap {
    display: inline-flex;
}
.flip-list-move {
    transition: transform 0.5s;
}
.header__tabs {
    height: 60px;
    display: inline-flex;
    align-items: flex-end;
    flex-wrap: nowrap;
    min-width: calc(100vw - 516px);
    &__item {
        position: relative;
        display: inline-flex;
        flex-grow: 1;
        justify-content: space-between;
        align-items: center;
        height: 48px;
        transition: all 0.3s;
        cursor: pointer;
        flex-direction: column;
        padding: 0 9px 0 12px;
        max-width: 140px;
        min-width: 70px;
        color: #666666;
        bottom: 1px;
        background: #24252c;
        box-shadow: 1px 0 4px 0 rgba(0, 0, 0, 0.5);
        border-radius: 2px 2px 0 0;
        margin-right: 1px;
        &.active {
            background-color: rgba(255, 255, 255, 0.29);
            color: rgba(102, 102, 102, 1);
            .name {
                color: rgba(255, 255, 255, 1);
            }
            .bottom-bg {
                display: block;
                background: linear-gradient(180deg, rgba(83, 83, 91, 0) 0%, rgba(0, 0, 0, 0.3) 100%);
            }
            &:hover {
                .del {
                    visibility: visible;
                }
            }
        }
        &:hover:not(.active) {
            background: rgba(61, 61, 71, 1);
            .del {
                visibility: visible;
            }
            .name {
                color: rgba(255, 255, 255, 1);
            }
            .bottom-bg {
                display: block;
                background: linear-gradient(180deg, rgba(83, 83, 91, 0) 0%, rgba(0, 0, 0, 0.3) 100%);
            }
        }
        .bottom-bg {
            display: none;
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            height: 14px;
            background-color: rgba(36, 37, 44, 1);
            filter: blur(0px);
        }
        .activator {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 38px;
            background: transparent;
            width: 100%;
        }
        .name {
            font-size: 14px;
            line-height: 14px;
            width: 0;
            flex: 1;
            color: #666;
        }
        .icon {
            width: 22px;
            height: 22px;
            margin: 4px 4px 4px 4px;
        }
        .del {
            transition: 0.3s;
            font-size: 14px;
            line-height: 18px;
            width: 18px;
            text-align: center;
            margin: 8px 0 8px 4px;
            border-radius: 9px;
            visibility: hidden;
            &:hover {
                background-color: rgba(255, 255, 255, 0.29);
            }
        }
    }
}

.menu {
    position: absolute;
}
</style>
